<template>
    <div class="flex justify-center items-center h-screen">
        <div class="text-center">
            <h1 class="mb-8 text-4xl">Pagina non trovata</h1>

            <h2>
                Sicuro di aver non aver sbagliato indirizzo?
            </h2>
        </div>
    </div>
</template>
